<script>
import {axios, swal} from "../../mixins";
import OperationsModal from "./OperationsModal.vue";
import DashUpload from "./DashUpload.vue";

export default {
  name: "FileManager",

  components: {
    OperationsModal,
    DashUpload
  },

  mixins: [axios, swal],

  props: {
    userId: {
      type: Number,
      required: true,
    },
    contractId: {
      type: Number,
      required: false
    },
    farm: {
      type: Object,
      required: true,
    },
    locked: {
      type: Boolean,
      required: false,
      default: false
    },
    years: {
      type: Array,
      required: false,
      default: []
    },
    year: {
      type: Number,
      required: false,
      default: 0
    }
  },

  data() {
    return {
      files: [],
      selectedYear: null,
      farmList: [],
      farmId: 0,
      name: '',
    }
  },

  created() {
    this.farmId = this.farm.id;
    this.name = this.farm.name;
    this.selectedYear = this.year;
  },

  computed: {
    getUrl() {
      return `/farms/` + this.farmId + `/files`
    },

    uploadUrl() {
      return `/farms/` + this.farmId + `/upload`
    },
  },

  methods: {
    getFarms() {
      this.get(this.userId + '/farms?year=' + this.selectedYear).then((response) => {
        this.farmList = response.data.farms
        this.farmId = Object.keys(this.farmList)[0]
        this.name = Object.values(this.farmList)[0]
        this.getFiles()
      })
    },

    getFiles() {
      this.name = this.farmList[this.farmId]
      this.get(this.getUrl).then((response) => {
        this.files = response.data.files;
        this.filterFiles()
      })
    },

    filterFiles() {
      this.files = this.files.filter(file => file.includes('w9') === false)
    },

    getBaseFilename(path) {
      // Handle both forward and backward slashes for cross-platform compatibility
      const lastSlashIndex = Math.max(path.lastIndexOf('/'), path.lastIndexOf('\\'));
      if (lastSlashIndex === -1) {
        // No path separators, the entire string is the filename
        return path;
      }
      return path.substring(lastSlashIndex + 1);
    }
  },
}
</script>

<template>
  <OperationsModal v-on:open="getFarms">
    <div class="w-full flex">
      <div class="rounded-t bg-secondary tab-shadow px-4 py-2 text-lg font-semibold block z-20">
        Files
      </div>
    </div>

    <div class="bg-secondary tab-shadow w-full p-2 round-tr">
      <div class="bg-primary p-2 w-full rounded flex flex-col">
        <div class="w-full flex flex-row justify-between border-b border-grey-lightest">
          <div class="my-auto font-semibold text-lg">{{ this.name }}</div>

          <div class="flex flex-row mb-1">
            <select name="year"
                    id="year"
                    v-model="this.selectedYear"
                    @change="getFarms()"
                    class="bg-tertiary italic border-b border-grey-light px-3 py-2 mx-1 rounded-md leading-tight focus:outline-none focus:ring">
              <option :value="null">Year</option>
              <option v-for="year in this.years" :value="year">{{ year }}</option>
            </select>
            <select name="farm"
                    id="farm"
                    v-model="this.farmId"
                    @change="getFiles()"
                    class="bg-tertiary italic border-b border-grey-light px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
              <option v-for="(farm, id) in this.farmList" :value="id">{{ farm }}</option>
            </select>
          </div>
        </div>

        <div class="h-64 overflow-x-scroll">
          <template v-for="(file, index) in this.files">
            <div :class="index % 2 === 0 ? 'bg-secondary' : 'bg-tertiary'"
                 class="p-1 pl-2 border-b border-grey-lightest">
              <a target="_blank" :href="this.getUrl + '/download?file=' + encodeURIComponent(file)">
                <p>{{ this.getBaseFilename(file) }}<i class="fas fa-arrow-up-right-from-square ml-2"/></p>
              </a>
            </div>
          </template>
        </div>

        <div v-if="!this.locked" class="justify-self-end">
          <DashUpload @getFiles="getFiles" :url="this.uploadUrl"></DashUpload>
        </div>
      </div>
    </div>

    <template #toggle="{open}">
      <button class="button bg-primary border-blue text-blue"
              @click="open"
              type="button"
              name="fileModal">
        <span>
          <i class="fas fa-files"/> File Management
        </span>
      </button>
    </template>

    <template #footer="{close}">
      <button type="button"
              class="button button-wide bg-tertiary text-sm hover:bg-grey-lighter focus:bg-grey-light"
              v-on:click="close">
        Close
      </button>
    </template>
  </OperationsModal>
</template>